<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="
        readyOnly
          ? `查看${titleName}指标`
          : isEditMode
          ? `编辑${titleName}指标`
          : `添加${titleName}指标`
      "
      :visible.sync="isShowDialog"
      width="580px"
      :before-close="dialogBeforeClose"
    >
      <div class="h460">
        <vue-scroll :ops="ops">
          <el-form
            :model="formData"
            :rules="formDataRules"
            :label-width="'120px'"
            ref="formDom"
          >
            <el-form-item label="指标名称" prop="targetSecondlyName">
              <el-input
                class="yioks-form-item"
                v-model.trim="formData.targetSecondlyName"
                :disabled="readyOnly"
                placeholder="请填充指标名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标分值" prop="targetSecondlyTotalScore">
              <el-input
                class="yioks-form-item"
                placeholder="请填充指标分值（示例：10）"
                v-model.trim.number="formData.targetSecondlyTotalScore"
                :disabled="readyOnly"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标权重" prop="secondlyWeight">
              <el-input
                class="yioks-form-item"
                placeholder="请填充指标权重（示例：10）"
                v-model.trim.number="formData.secondlyWeight"
                :disabled="readyOnly"
              ></el-input>
            </el-form-item>

            <el-form-item label="三级指标名称" prop="targetThirdlyName">
              <el-input
                class="yioks-form-item"
                placeholder="请填写三级指标名称"
                v-model.trim="formData.targetThirdlyName"
                :disabled="readyOnly"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否必传文件">
              <el-radio-group v-model="formData.isNeedFile" :disabled="readyOnly">
                <el-radio :label=1>是</el-radio>
                <el-radio :label=0>否</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- <el-form-item label="计分类型" prop="targetType">
              <el-select
                v-model="formData.targetType"
                class="yioks-form-item"
                placeholder="请选择计分类型"
                :disabled="readyOnly"
              >
                <el-option
                  v-for="(item, index) in gradeType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="指标材料">
              <el-upload
                class="yioks-form-item"
                :action="uploadPath"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :before-upload="beforeUpload1"
                :on-exceed="handleExceed"
                :data="uploadfile"
                :file-list="uploadFileList"
                :disabled="readyOnly"
                :limit="1"
              >
                <el-button size="small" type="primary" :disabled="readyOnly"
                  >点击上传</el-button
                >
                <div slot="tip" class="el-upload__tip">单个上传文件不超过50M</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="指标备注" prop="targetSecondlyRemark">
              <el-input
                type="textarea"
                class="yioks-form-item"
                v-model="formData.targetSecondlyRemark"
                placeholder="请填写指标备注"
                :disabled="readyOnly"
                :rows="3"
              ></el-input>
            </el-form-item>

            <el-form-item label="指标建议" prop="targetSecondlySuggest">
              <el-input
                type="textarea"
                class="yioks-form-item"
                v-model="formData.targetSecondlySuggest"
                placeholder="请填写指标建议"
                :disabled="readyOnly"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-form>
        </vue-scroll>
      </div>
      <div slot="footer" class="footer-btn-group" v-if="!readyOnly">
        <el-button type="primary" @click="handleDialogAction(true)"
          >确 定</el-button
        >
        <el-button type="danger" @click="handleDialogAction(false)"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { performanceGroupTypeList, gradeType } from "@/assets/js/yioksSelect";
import {
  postTarget,
  putTarget,
  addSecondTarget,
  editSecondTarget,
  deleteSecondTargetFile,
} from "@/api/performance";
import { ops } from "@/utils/scrollIndialog";

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    maxScore: {
      type: Number,
      default: 0,
      required: false,
    },
    isLimitMaxScore: {
      type: Boolean,
      default: false,
      required: false,
    },
    defaultFormData: {
      type: Object,
      default() {
        return {
          targetSecondlyName: "", // 指标名称
          targetSecondlyTotalScore: "", // 指标总分值
          // targetType: "TALLEST", // 计分类型
          targetUuid: "", // 上级指标 父级指标 // 初始填值
          secondlyWeight: "", // 权重 Number
          targetThirdlyName: "", // 三级指标名称
          // jixiaoType: "", // 指标类型
          groupUuid: "", // 绩效组uuid  // 初始填值
          targetSecondlyRemark: "", // 指标备注
          targetSecondlySuggest: "", // 指标建议
          isFileChanged: false,
        };
      },
    },

    isEditMode: {
      type: Boolean,
      default: false,
      required: false,
    },

    targetUuid: {
      type: String,
      default: "",
      required: false,
    },

    titleName: {
      type: String,
      default: "",
      required: false,
    },

    readyOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  components: {
    "upload-file": () => import("@/components/UploadFile"),
  },

  data() {
    return {
      ops,
      oldScore: 0,
      uploadfile: {
        jixiao: "",
      },
      // uploadPath: '/api/zuxie/guozi/upload/uploadJixiaoFile',
      uploadPath: "/api/zuxie/guozi/upload/jixiao",
      formData: {
        targetSecondlyName: "", // 指标名称
        targetSecondlyTotalScore: "", // 指标总分值
        // targetType: "TALLEST", // 计分类型
        targetUuid: "", // 上级指标 父级指标 // 初始填值
        secondlyWeight: "", // 权重 Number
        targetThirdlyName: "", // 权重 Number
        // jixiaoType: "", // 指标类型
        groupUuid: "", // 绩效组uuid  // 初始填值
        targetSecondlyRemark: "", // 指标备注
        targetSecondlySuggest: "", // 指标建议

        targetFileName: "",
        targetTemplateFileUrl: "", // 指标模板文件url
        md5: "", // 指标文件MD5
        isNeedFile: 1, // 是否需要必传证明材料
      },
      uploadFileList: [],
      performanceGroupTypeList, // 指标类型列表
      gradeType,
    };
  },

  computed: {
    groupNameUuid() {
      const { groupUuid } = this.$route.params;
      return groupUuid;
    },
    // 表单验证规则
    formDataRules() {
      const rules = {
        targetSecondlyName: [requiredItem("指标名称")],
        targetSecondlyTotalScore: [
          requiredItem("指标分值"),
          numberRequired("指标分值"),
          {
            required: false,
            validator: (rule, value, callBack) => {
              if (this.isLimitMaxScore) {
                if (value !== "") {
                  let _score = this.maxScore;
                  if(this.isEditMode) {
                    _score += this.oldScore
                  }
                  if (value > _score) {
                    callBack(
                      new Error(`当前指标最多允许分值为${_score}分`)
                    );
                  } else {
                    callBack();
                  }
                } else {
                  callBack();
                }
              } else {
                callBack();
              }
            },
            trigger: "blur",
          },
        ],
        secondlyWeight: [requiredItem("权重"), numberRequired("权重", true)],
        targetThirdlyName: [requiredItem("三级指标")],
        // targetType: [requiredItem("计分类型")],
        // jixiaoType: [requiredItem("指标类型")],
      };
      return rules;
    },
  },

  created() {
    this.initFormData(); // 填充原始表单
  },

  methods: {
    // 对原始表单填值
    initFormData() {
      if (this.groupNameUuid)
        this.$set(this.formData, "groupUuid", this.groupNameUuid);
      if (this.targetUuid)
        this.$set(this.formData, "targetUuid", this.targetUuid);
      if (this.isEditMode) {
        const { md5, targetTemplateFileUrl, targetFileName } =
          this.defaultFormData;
        if (md5) {
          this.uploadFileList.push({
            name: targetFileName,
            url: targetTemplateFileUrl,
            id: md5,
          });
        }
        this.oldScore = this.defaultFormData.targetSecondlyTotalScore;  // 编辑模式下需要暂存当前分数
        this.formData = Object.assign({}, this.formData, this.defaultFormData);
      }
    },

    // 表单操作
    handleDialogAction(confirm) {
      if (confirm) {
        this.$refs.formDom.validate((valid) => {
          if (valid) {
            let requestName = this.isEditMode
              ? editSecondTarget
              : addSecondTarget;
            let submitData = {};
            if (!this.isFileChanged) {
              const {
                md5,
                targetTemplateFileUrl,
                targetFileName,
                ...firstSubmitData
              } = this.formData;
              submitData = firstSubmitData;
            } else {
              const { targetThirdlyName, secondlyWeight, targetSecondlyName, targetSecondlyRemark, targetSecondlySuggest, targetSecondlyTotalScore, targetUuid, ...restObj } = this.formData;
              submitData = {
                ...restObj,
                secondlyWeight: secondlyWeight,
                targetThirdlyName: targetThirdlyName,
                targetSecondlyName: targetSecondlyName,
                targetSecondlySuggest: targetSecondlySuggest,
                targetSecondlyRemark: targetSecondlyRemark,
                targetSecondlyTotalScore: targetSecondlyTotalScore,
                targetUuid: targetUuid
              };
            }
            const { targetLableList, ...rest} = submitData;
            let submitDataForRequest = {};
            if(this.isEditMode) {
              submitDataForRequest = rest
            } else {
              submitDataForRequest = submitData;
            }
            requestName(submitDataForRequest)
              .then((res) => {
                if (res.code) {
                  this.$message.error(res.msg);
                  this.setCallBack(true, false);
                  return;
                }
                this.setCallBack(false, true);
              })
              .catch((err) => {
                console.error("err", err);
                this.setCallBack(false, false);
              });
          } else {
            console.warn("校验未通过");
          }
        });
      } else {
        // this.$emit("update:isShowDialog", false);
        this.setCallBack(false, false);
      }
    },

    // 设置弹窗状态
    setDialogStatus(status) {
      this.$emit("update:isShowDialog", status);
    },

    // 设置弹窗回调方法
    setCallBack(dialogStatus, successStatus) {
      this.uploadFileList = [];
      this.$emit("closeDialogCallBack", dialogStatus, successStatus);
    },

    // 弹窗关闭
    dialogBeforeClose() {
      this.setCallBack(false, false);
    },

    // 文件超出
    handleExceed() {
      this.$message.error(this.$t("uploadFileTips"));
    },
    beforeUpload1(file) {
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error(this.$t("文件大小不能超过50M！"));
      }
      if (fileLimit) {
        this.uploadfile.jixiao = file;
      }
      return fileLimit;
    },
    handleSuccess(res, file, fileList) {
      /*
       targetFileName: '',
        targetTemplateFileUrl: "", // 指标模板文件url
        md5: "", // 指标文件MD5
       */
      this.isFileChanged = true;
      const { fileMd5, fileName, url, fileTmp } = res;
      fileMd5 && this.$set(this.formData, "md5", fileMd5);
      fileName && this.$set(this.formData, "targetFileName", fileName);
      url && this.$set(this.formData, "targetTemplateFileUrl", url);
    },
    handleRemove(file, fileList) {
      const { md5, targetFileName, targetTemplateFileUrl, uuid } = this.formData;
      deleteSecondTargetFile(uuid)
        .then(res => {
          if(res.code){
            this.$message.error(res.msg);
            return
          }
          if (this.uploadFileList.length) this.uploadFileList = [];
          this.$message.success('文件已删除');
        }).catch(err => {
          console.error('err', err)
        })
      md5 && this.$set(this.formData, "md5", "");
      targetFileName && this.$set(this.formData, "targetFileName", "");
      targetTemplateFileUrl &&
        this.$set(this.formData, "targetTemplateFileUrl", "");

    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.h460
  height 460px
</style>
